import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.73 7.357a3.73 3.73 0 0 1-1.685-3.107h-2.67v10.695a2.253 2.253 0 0 1-2.247 2.16c-.374 0-.724-.1-1.036-.263a2.242 2.242 0 0 1-1.198-1.984 2.253 2.253 0 0 1 2.246-2.247c.225 0 .45.038.662.1v-2.72a5.683 5.683 0 0 0-.662-.05 4.913 4.913 0 0 0-4.904 4.904c0 1.66.836 3.133 2.096 4.019a4.913 4.913 0 0 0 7.725-4.019V9.43a6.378 6.378 0 0 0 3.707 1.198v-2.67a3.734 3.734 0 0 1-2.022-.6h-.012Z",
      fill: "#616a75"
    }, null, -1)
  ])))
}
export default { render };